import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonInput, IonModal } from '@ionic/angular';
import { ColumnMode, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { etkezesIdoszakOsszeg } from 'src/app/util/etkezes-ar';

@Component({
  selector: 'app-egyenleg',
  templateUrl: './egyenleg.component.html',
  styleUrls: ['./egyenleg.component.scss'],
})
export class EgyenlegComponent implements OnInit {

  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly JSON = JSON;

  sajatIntezmeny
  intezmeny = 2
  dolgozok = 0
  tanulok = 0
  felulet = 0
  import = 0
  besorolas = 0
  enaplo = 0
  dokumentumok = 0
  adatszolg = 0
  penzugy = 0
  modulok = 0
  munkatarssorok = [];
  datetime
  alkalmazk
  alkalmazv

  selected = [];
  telepules
  allampolgar
  orszag
  SelectionType = SelectionType;
  allomany
  csoport
  @ViewChild("uzenetmodal") modal: IonModal;
  @ViewChild("bizonylatmodal") bizmodal: IonModal;
  @ViewChild("tetelmodal") tetelmodal: IonModal;
  @ViewChild("osztalymodal") osztalymodal: IonModal;
  @ViewChild("osztalytetelmodal") osztalytetelmodal: IonModal;
  @ViewChild("tomegesmodal") tomegesmodal: IonModal;
  // Tömeges ebédkiírás állapota (év/hónap, számítás eredménye családonként, haladás).
  tomeges: any = { ev: moment().year(), honap: moment().month() + 1, idoszak: 'teljes', nap_tol: 1, nap_ig: 15, fut: false, kesz: false, sorok: [], halad: 0, total: 0, dijbekero: false, biztomb: '' };

  /*  KÉTHETI (FÉLHAVI) SZÁMLÁZÁS.
   *
   *  Az ebéd eddig csak egész hónapra volt kiírható. A tartomány a hónapon BELÜL
   *  marad: az egyenleg, a storno-visszaállítás és maga az étkezés-rács is hónapra
   *  szervezett, egy hónapokon átnyúló 14 napos ciklus mindegyiket kettétörné.
   *  A gyakorlatban ez ugyanaz: 1–15., majd 16-tól a hónap végéig.
   */
  idoszakOpciok = [
    { id: 'teljes', nev: 'Egész hónap' },
    { id: 'elso', nev: '1–15. (első fél hónap)' },
    { id: 'masodik', nev: '16-tól a hónap végéig' },
    { id: 'egyedi', nev: 'Egyedi nap-tartomány' },
  ];

  /** A hónap napjainak száma (szökőévvel együtt). */
  private honapNapjai(ev: any, honap: any): number {
    const e = Number(ev), h = Number(honap);
    if (!e || !h) return 31;
    return new Date(e, h, 0).getDate();
  }

  /** A választott időszak tényleges nap-határa. Ismeretlen választásnál teljes hónap. */
  idoszakHatar(forras: any): { tol: number; ig: number; reszleges: boolean } {
    const utolso = this.honapNapjai(forras?.ev, forras?.honap);
    let tol = 1, ig = utolso;
    if (forras?.idoszak === 'elso') { tol = 1; ig = Math.min(15, utolso); }
    else if (forras?.idoszak === 'masodik') { tol = Math.min(16, utolso); ig = utolso; }
    else if (forras?.idoszak === 'egyedi') {
      tol = Math.min(Math.max(1, Number(forras?.nap_tol) || 1), utolso);
      ig = Math.min(Math.max(1, Number(forras?.nap_ig) || utolso), utolso);
      if (ig < tol) { const cs = tol; tol = ig; ig = cs; }
    }
    return { tol, ig, reszleges: !(tol === 1 && ig === utolso) };
  }

  /** A kiírt tétel megnevezésének időszak-része. Egész hónapnál üres (a régi név marad). */
  idoszakCimke(forras: any): string {
    const h = this.idoszakHatar(forras);
    return h.reszleges ? ` (${h.tol}–${h.ig}.)` : '';
  }
  segment = "3"
  bizonylattipus = 0;
  bizonylatok = ["-", "számla", "előleg számla", "díjbekérő", "nyugta", "árajánlat", "szállítólevél", "teljesítésigazolás", "stornószámla"]
  invoices

  portControl: FormControl;
  form: FormGroup;
  egyenleg: any = {}
  oegyenleg
  csegyenleg
  csegyenlegid
  kovetel
  kovetelnullaz
  jovair
  osszesTetel: any[] = []        // szülői egységes lista-nézet (követelés+jóváírás egyben)
  legacyNezet = false            // true: régi 2-oszlopos nézet

  /*  Hibásan kiírt tétel javítása (admin).
   *
   *  Eddig egy elrontott kiírást nem lehetett rendbe tenni: a storno csak SZÁMLÁRA
   *  működik, a puszta követelésre nem. Itt a kiírás megnevezése/összege javítható és
   *  a tétel törölhető – de csak amíg nincs róla végszámla és nincs rá befizetés.
   *  A hozzá tartozó díjbekérő külön érvényteleníthető (a sorszám megmarad).
   */
  tetelSzerk: any = null;        // { id, nev, osszeg }
  tetelMuvelet = false;
  egyenlegModalView: 'parositott' | 'tablazat' = 'parositott'
  parositottTetelek: any[] = []
  parositatlanJovairasok: any[] = []
  kiirasBizonylatok: any = {}     // kiírás(egyenleg id) → hozzá tartozó bizonylat (resolver endpointból)
  bizonylatKartyak: any[] = []    // szülői nézet: a számlalista (/bizonylatokcsalad) feldolgozott kártyái
  aktivEgyenlegUserId            // az utoljára betöltött család/felhasználó (újratöltéshez párosítás után)
  tetelek: any = []
  tetel: FormGroup;
  osztalytetel: FormGroup;
  ebedusers = []
  loginmode

  /*  CSALÁDI NÉZET: gondviselő VAGY a saját nevében belépő tanuló.
   *
   *  A pénzügy a CSALÁD nyilvántartása. A tanulói belépést eddig semmi nem
   *  kezelte, ezért mindenhol az „egyébként" ág futott – az intézményi nézet,
   *  adminisztrátori műveletekkel. Egy helyen dől el, hogy ki számít családnak.
   */
  get csaladiNezet(): boolean {
    return this.loginmode === 'gondviselo' || this.loginmode === 'tanulo';
  }
  /** Tétel párosítása – a Jogosultságok szerkesztőben állítható művelet. */
  parosithat = false;
  userMetadata
  tombok
  egyenlegMode = "2"
  zsebek = []
  osztalyok = []

  constructor(private http: HttpClient, private data: DataService,
    private formBuilder: FormBuilder) {

    this.portControl = this.formBuilder.control(
      { id: 142, nev: "magyar" },
      Validators.required
    );
    this.form = this.formBuilder.group({
      anyanyelv: this.portControl,
      allampolgar1: this.portControl,
      allampolgar2: this.portControl,
      alkalmazk: new FormControl("", Validators.required),
      alkalmazv: new FormControl(""),
      orszag: new FormControl({ id: 142, nev: "Magyarország" }, Validators.required)
    });
    this.tetel = this.formBuilder.group({
      tipus: new FormControl("", Validators.required),
      nev: new FormControl("", Validators.required),
      osszeg: new FormControl("", Validators.required),
      szamla: new FormControl(0),
      alrendszer: new FormControl(""),
      ev: new FormControl(""),
      honap: new FormControl(""),
      koveteles: new FormControl(""),
      dijbekero: new FormControl(false),
      biztomb: new FormControl(""),
      // Kétheti (félhavi) számlázás: a hónapon belüli nap-tartomány.
      idoszak: new FormControl("teljes"),
      nap_tol: new FormControl(1),
      nap_ig: new FormControl(15),
    });
    this.osztalytetel = this.formBuilder.group({
      tipus: new FormControl("", Validators.required),
      nev: new FormControl("", Validators.required),
      osszeg: new FormControl("", Validators.required),
      zseb: new FormControl("", Validators.required),
      szla: new FormControl(""),
    });
  }
  async tipusValt() {
    if (this.tetel.value.tipus == "Követelés alrendszerből" || this.tetel.value.tipus == "Jóváírás alrendszerből") {

      this.tetel.patchValue({
        nev: this.tetel.value.alrendszer + " - " + this.tetel.value.honap + ". hónap"
          + this.idoszakCimke(this.tetel.value),
      })

    }
  }
  async getAdatFromAlrendszer() {
    await this.data.showLoading("Adatok betöltése...")
    let body = []
    this.ebedusers = []
    body = this.csegyenleg.users.filter((item: any) => item.type === "tanulo").map((item: any) => ({ oktazon: item.id }));
    this.ebedusers = body
    console.log(body)
    this.http
      .post(
        '/api/etkezes/tanulo/' + this.tetel.value.ev + '/' + this.tetel.value.honap + '/' + this.sajatIntezmeny.intezmenyId,//'https://idp.zenit.cronom.it/admin/realms/master/users?q=title:oktató',
        body
      )
      .subscribe({
        next: (response: any) => {
          console.log(response);
          this.data.hideLoading()
          let vegosszeg = 0;

          const hatar = this.idoszakHatar(this.tetel.value);
          response.forEach((element) => {
            element.adatok = JSON.parse("[" + element.adatok + "]");
            try { element.etkezes_hely_adatok = JSON.parse(element.etkezes_hely_adatok); } catch (e) { }
            vegosszeg += etkezesIdoszakOsszeg(element, hatar.tol, hatar.ig);
          });
          this.tetel.patchValue({ osszeg: vegosszeg })
        },
        error: (error) => {
          this.data.hideLoading()
          console.error('Error fetching data:', error);
        },
      });

  }
  async getAdatFromKoveteles(kov) {
    kov = kov.detail.value
    this.tetel.patchValue({ alrendszer: kov.alrendszer, nev: kov.nev + " jóváírás", osszeg: kov.osszeg })
  }
  // Melyik fizetési szolgáltató gombját mutassuk (adminban állítható: Stripe / OTP
  // SimplePay / mindkettő). Alapértelmezés a régi Stripe, így hiba esetén sem tűnik
  // el a fizetés lehetősége.
  fizetesMod: any = { szolgaltato: 'stripe', stripe: true, simple: false };

  async loadFizetesMod() {
    try {
      const iid = encodeURIComponent(this.sajatIntezmeny?.intezmenyId || '');
      const r: any = await this.http.get(`/api/simplepay/status?intezmeny=${iid}`).toPromise();
      if (r && !r.error) this.fizetesMod = r;
    } catch (e) { /* marad a Stripe */ }
    this.loadFizetesFeldolgozas()
  }

  // Azok a bizonylatok, amelyekre már megérkezett a fizetés, de a könyvelés (számla,
  // egyenleg, díjbekérő-lezárás) még nem futott le. Ilyenkor a fizetés gomb helyett
  // jelzést mutatunk, különben a szülő ugyanazt kétszer fizetné ki.
  fizetesFeldolgozas = new Set<string>();
  /**
   *  Már kifizetett és lekönyvelt bizonylatok. A díjbekérő státusza csak a végszámla
   *  kiállításakor fordul át „rendezett"-re, ezért enélkül a sikeres fizetés után is
   *  aktív maradna a fizetés gomb – és újra ki lehetne fizetni ugyanazt.
   */
  marKifizetett = new Set<string>();

  async loadFizetesFeldolgozas() {
    try {
      const iid = encodeURIComponent(this.sajatIntezmeny?.intezmenyId || '');
      const r: any = await this.http.get(`/api/simplepay/folyamatban?intezmeny=${iid}`).toPromise();
      this.fizetesFeldolgozas = new Set<string>(r?.bizidk || []);
      this.marKifizetett = new Set<string>(r?.kifizetett || []);
    } catch (e) {
      this.fizetesFeldolgozas = new Set<string>();
      this.marKifizetett = new Set<string>();
    }
  }

  /* ── Több bizonylat egyben (bulk fizetés) ── */

  /** A szülő által kijelölt, egyszerre fizetendő bizonylatok. */
  kijeloltFizetes = new Set<string>();

  fizetesKijelol(bizid: any, be: boolean) {
    const kulcs = String(bizid || '');
    if (!kulcs) return;
    if (be) this.kijeloltFizetes.add(kulcs); else this.kijeloltFizetes.delete(kulcs);
  }

  kijelolve(bizid: any): boolean {
    return this.kijeloltFizetes.has(String(bizid || ''));
  }

  /** A kijelölt, ténylegesen fizethető kártyák (a feldolgozás alattiak kimaradnak). */
  get kijeloltKartyak(): any[] {
    return (this.bizonylatKartyak || []).filter((c: any) =>
      this.kijelolve(c.id) && this.bizFizetheto(c) && !this.feldolgozasAlatt(c.id));
  }

  get kijeloltOsszeg(): number {
    return this.kijeloltKartyak.reduce((s, c) => s + (Number(c.osszesen) || 0), 0);
  }

  /**
   *  Egy fizetés, több számla. A SimplePay-nél egy tranzakció egy összeg, ezért a
   *  szétosztást a szerver tartja nyilván – a visszaigazolás után számlánként ír jóvá.
   */
  async kijeloltekFizetese() {
    const idk = this.kijeloltKartyak.map((c: any) => c.id);
    if (!idk.length) { this.data.sendToast('Nincs kijelölt fizethető bizonylat.', 'warning'); return; }
    //  Az ablakot a kattintásra AZONNAL nyitjuk (a mobil böngésző a várakozás utáni
    //  window.open-t letiltja), és a jegyek megérkezése után irányítjuk a fizetőoldalra.
    const ablak = (window as any).Capacitor?.isNativePlatform?.() ? null : window.open('about:blank', '_blank');
    const toldat = (await this.probaToldat()) + (await this.fizetoToldat());
    const cel = `/api/simplepay/form-tobb?ids=${encodeURIComponent(idk.join(','))}${toldat}`;
    if (ablak) ablak.location.href = cel; else window.open(cel, '_blank');
  }

  /*  PRÓBAÜZEM: a fizetőoldal ÚJ FÜLBEN nyílik, ahol nincs belépési jegy — ott tehát
   *  nem lehet megkérdezni, admin-e a látogató. Ezért előbb kérünk egy rövid életű
   *  kulcsot (ahhoz kell a belépés és az admin jog), és azzal nyitjuk meg az oldalt. */
  /*  FIZETŐ-JEGY: a SimplePay a BELÉPETT felhasználó adataival (név, e-mail, cím) induljon,
   *  ne a díjbekérő címzettjéével – több bizonylat egyszerre is fizethető, és a címzettnek
   *  nem mindig van rögzített címe. Az új fülön nincs belépési jegy, ezért előbb kérünk egy
   *  rövid életű kulcsot (backend/checkout-simple.js › /fizeto-jegy). */
  private async fizetoToldat(): Promise<string> {
    try {
      const r: any = await this.http.get('/api/simplepay/fizeto-jegy').toPromise();
      return r?.kulcs ? `&fizeto=${encodeURIComponent(r.kulcs)}` : '';
    } catch (e) { return ''; }
  }

  private async probaToldat(): Promise<string> {
    if (!this.fizetesMod?.probauzem) return '';
    try {
      const iid = this.sajatIntezmeny?.intezmenyId || '';
      const r: any = await this.http
        .get(`/api/simplepay/proba-jegy?intezmeny=${encodeURIComponent(iid)}`).toPromise();
      return r?.kulcs ? `&proba=${encodeURIComponent(r.kulcs)}` : '';
    } catch (e) { return ''; }
  }

  /** Egy bizonylat fizetőoldalának megnyitása (próbaüzemben kulccsal). */
  async fizetesMegnyit(bizid: any, mod: 'stripe' | 'simple') {
    const ablak = (window as any).Capacitor?.isNativePlatform?.() ? null : window.open('about:blank', '_blank');   // azonnal (mobil felugró-tiltás)
    const toldat = (await this.probaToldat()).replace(/^&/, '&') + (mod === 'simple' ? await this.fizetoToldat() : '');
    const alap = mod === 'simple' ? '/api/simplepay/form?id=' : '/api/checkout/form?id=';
    const cel = `${alap}${encodeURIComponent(bizid)}${toldat}`;
    if (ablak) ablak.location.href = cel; else window.open(cel, '_blank');
  }

  /** Nincs elérhető fizetőkapu ennek a felhasználónak. */
  get nincsFizetokapu(): boolean {
    return !this.fizetesMod?.stripe && !this.fizetesMod?.simple;
  }

  feldolgozasAlatt(bizid: any) {
    return !!bizid && this.fizetesFeldolgozas.has(String(bizid));
  }

  // "Befizetés" → "Befizetés (SimplePay)", ha egyszerre több mód is látszik.
  fizetesFelirat(alap: string, mod: 'stripe' | 'simple') {
    if (this.fizetesMod?.szolgaltato !== 'mindketto') return alap;
    return alap + (mod === 'simple' ? ' (SimplePay)' : ' (kártya)');
  }

  async ngOnInit() {
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    this.loginmode = (await this.data.getFromStorage("loginmode"))
    this.parosithat = (await this.data.hozzaferesek()).szabad('/penzugy/egyenleg#parositas');
    this.loadFizetesMod()

  /*  CSALÁDI NÉZET: gondviselő VAGY a saját nevében belépő tanuló.
   *
   *  A pénzügy a CSALÁD nyilvántartása – a kiírás, a díjbekérő és a számla a
   *  családhoz tartozik, nem egyetlen személyhez. A tanulói belépést eddig
   *  semmi nem kezelte, ezért az „egyébként" ág futott le: az INTÉZMÉNYI
   *  nézet, a többi család bizonylataival. A menüből eddig azért nem lehetett
   *  odajutni, mert egy bedrótozott lista kiszűrte a tanuló menüjét – a
   *  jogosultság megadása mégis odavezetett volna.
   */
    if (this.csaladiNezet) {
      this.egyenlegMode = "1"
      this.userMetadata = await this.data.getFromStorage("userMetadata")
      //this.egyenleg = JSON.parse((await this.data.getFromStorage("egyenleg")))
      //console.log(this.userMetadata.username)
      this.csegyenlegid = 0
      await this.getEgyenlegReszletes(this.userMetadata.username)
      await this.getBizonylatok(this.userMetadata.username)
    } else {
      this.egyenlegMode = "1"
      await this.getZsebek()
      await this.getEgyenleg()
    }
    this.getTomb()
    //this.egyenleg = JSON.parse((await this.data.getFromStorage("egyenleg")))
    //if(this.egyenleg.tetelek) this.tetelek = JSON.parse(this.egyenleg.tetelek)

    //this.getAllomany();
  }
  async getTomb() {
    await this.http
      .get(
        '/api/szamla/tombok/' + this.sajatIntezmeny.intezmenyId,
        {

        }
      )
      .subscribe({
        next: (response) => {
          this.tombok = response
          //console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  }
  async getZsebek() {
    await this.http
      .get(
        '/api/osztaly/egyenleg/zseb/' + this.sajatIntezmeny.intezmenyId,
        {

        }
      )
      .subscribe({
        next: (response: any) => {
          this.zsebek = response
          //console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  }

  async getEgyenleg() {
    this.egyenleg = []
    await this.http
      .get(
        '/api/egyenleg',
        {

        }
      )
      .subscribe({
        next: (response) => {
          this.egyenleg = response
          //console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
    this.osztalyEvekBetolt()
    this.osztalyEgyenlegBetolt()
  }

  /* ── OSZTÁLYEGYENLEG: TANÉV ─────────────────────────────────────────────────
     Tanévváltáskor minden osztály ÚJ sorként jön létre, a régi pedig megmarad –
     ezért a lista korábban a tavalyi osztályokat is hozta, ugyanazokkal a nevekkel.
     Alapból a futó tanév látszik; a választóval egy korábbi év is elővehető, mert a
     régi egyenlegek nem tűnnek el, csak nem keverednek az ideibe. */

  /** A választható tanévek (csak amihez tartozik osztály). */
  osztalyEvek: number[] = [];

  /** A mai nap szerinti tanév – ezt jelöljük meg a listában. */
  aktualisTanev: number | null = null;

  /** A megjelenített tanév (null = a futó tanév, ezt kéri a kiszolgáló alapból). */
  valasztottTanev: number | null = null;

  private osztalyEvekBetolt() {
    const intezmeny = this.sajatIntezmeny?.intezmenyId;
    if (!intezmeny) return;
    this.http.get<any>('/api/osztaly/egyenleg-evek/' + intezmeny).subscribe({
      next: (v) => {
        this.osztalyEvek = Array.isArray(v?.evek) ? v.evek : [];
        this.aktualisTanev = v?.aktualis ?? null;
      },
      //  A választó kiegészítés: ha nem jön le, a lista attól még működik.
      error: () => { this.osztalyEvek = []; this.aktualisTanev = null; },
    });
  }

  osztalyEgyenlegBetolt() {
    const szuro = this.valasztottTanev ? `?ev=${this.valasztottTanev}` : '';
    this.http.get('/api/osztaly/egyenleg' + szuro).subscribe({
      next: (response) => { this.oegyenleg = response },
      error: (error) => { console.error('Error fetching data:', error); },
    })
  }

  /** Tanév-váltás a választóból. */
  tanevValt(ev: any) {
    this.valasztottTanev = ev === null || ev === undefined || ev === '' ? null : Number(ev);
    this.csegyenlegid = null;
    this.osztalyEgyenlegBetolt();
  }
  // Minden kiíráshoz a hozzá tartozó bizonylat (díjbekérő/számla/storno/módosító) betöltése.
  async getKiirasBizonylatok(id) {
    try {
      const resp: any = await this.http.get('/api/kiiras-bizonylatok/' + id).toPromise();
      this.kiirasBizonylatok = (resp && typeof resp === 'object' && !resp.error) ? resp : {};
    } catch {
      this.kiirasBizonylatok = {};
    }
  }

  // SZÜLŐI NÉZET: a számlalista (/bizonylatokcsalad) betöltése + kártyákká alakítása.
  // Megbízható (közvetlenül a bizonylatokat mutatja), nem a törékeny kiírás-párosítást.
  async getBizonylatok(id) {
    try {
      const resp: any = await this.http.get('/api/szamla/bizonylatokcsalad/' + id).toPromise();
      const docs = Array.isArray(resp) ? resp : [];
      // Számla (tipus 1), amely díjbekérőből készült → összevonjuk a díjbekérővel.
      const dijIds = new Set(docs.filter((d: any) => String(d.tipus) === '3').map((d: any) => String(d.id)));
      const invByProforma: any = {};
      docs.forEach((d: any) => { if (String(d.tipus) === '1' && d.proforma_id) invByProforma[String(d.proforma_id)] = d; });

      this.bizonylatKartyak = docs
        // a díjbekérőhöz tartozó végszámlát nem külön kártyaként, hanem alsorként mutatjuk
        .filter((d: any) => !(String(d.tipus) === '1' && d.proforma_id && dijIds.has(String(d.proforma_id))))
        .map((d: any) => {
          const inv = String(d.tipus) === '3' ? invByProforma[String(d.id)] : null;
          const card: any = { ...d };
          card.vegszamla = inv ? inv.id : null;
          card.vegszamlaszam = inv ? inv.szamlaszam : null;
          card.bizStatus = this.bizonylatStatus(d, !!inv);
          return card;
        })
        .sort((a: any, b: any) => String(b.created_at || '').localeCompare(String(a.created_at || '')));
    } catch {
      this.bizonylatKartyak = [];
    }
  }

  // Bizonylat fizetési státusza (a Bizonylatok lista logikájával).
  // '1'=rendezve, '0'=esedékes, '-1'=lejárt, 'nf'=nem fizetendő (storno/mínuszos).
  bizonylatStatus(f: any, vanVegszamla = false): string {
    if (Number(f.tipus) === 8 || Number(f.osszesen) < 0) return 'nf';
    if (vanVegszamla) return '1';                                  // díjbekérőből készült számla → kifizetve
    let paid = false;
    (f.tranzakciok || []).forEach((g: any) => { if (g.paid === true) paid = true; });
    if (paid) return '1';
    return moment(f.fiz_hat).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD') ? '0' : '-1';
  }

  // Bizonylat-kártya: státusz-ikon + címke + esedékesség (a számlalista ikonjaival).
  bizIcon(s: string): { src: string; title: string } {
    if (s === '1') return { src: 'assets/icon/icons8-today-96.png', title: 'Rendezve' };
    if (s === '-1') return { src: 'assets/icon/icons8-leave-96.png', title: 'Lejárt' };
    if (s === '0') return { src: 'assets/icon/icons8-tomorrow-96.png', title: 'Esedékes' };
    return { src: '', title: 'Nem fizetendő' };
  }
  bizStatusLabel(s: string): string {
    if (s === '1') return 'Rendezve';
    if (s === '-1') return 'Lejárt';
    if (s === '0') return 'Esedékes';
    return 'Nem fizetendő';
  }
  bizLejaratSzoveg(card: any): string {
    if (card.bizStatus !== '0' && card.bizStatus !== '-1') return '';
    if (!card.fiz_hat) return '';
    const nap = moment(card.fiz_hat).diff(moment(), 'days');
    if (nap > 0) return `Esedékességig ${nap} nap`;
    if (nap === 0) return 'Ma esedékes';
    return `${Math.abs(nap)} napja lejárt`;
  }
  bizFizetheto(card: any): boolean {
    if (this.marKifizetett.has(String(card?.id || ''))) return false;
    return card.bizStatus !== '1' && card.bizStatus !== 'nf'
      && Number(card.osszesen) > 0 && Number(card.tipus) !== 8 && card.storno != 1;
  }
  // A bizonylat első tételének neve (fejléchez), ill. hány tétel van.
  bizFotetel(card: any): string {
    const t = card?.tetelek;
    if (Array.isArray(t) && t.length) return t[0]?.nev || '';
    return '';
  }
  bizTobbTetel(card: any): boolean {
    return Array.isArray(card?.tetelek) && card.tetelek.length > 1;
  }

  async getEgyenlegReszletes(id) {
    this.egyenleg = []
    this.csegyenleg = []
    await this.getKiirasBizonylatok(id)
    await this.http
      .get(
        '/api/egyenlegreszletes/' + id,
        {

        }
      )
      .subscribe({
        next: (response) => {
          this.egyenleg = response
          this.csegyenleg = this.egyenleg
          this.csegyenleg.csalad = this.egyenleg.csalad
          this.csegyenleg.users = JSON.parse(this.egyenleg.csalad_reszletek)
          if (!this.csegyenleg.egyenleg) this.csegyenleg.egyenleg = 0
          this.kovetel = JSON.parse(this.egyenleg.tetelek).filter(s => s.osszeg >= 0)
          this.kovetelnullaz = JSON.parse(this.egyenleg.tetelek).filter(s => s.osszeg >= 0 && s.kapcsolat == null)
          this.jovair = JSON.parse(this.egyenleg.tetelek).filter(s => s.osszeg < 0)
          // Egységes lista-nézet: minden tétel egyben, dátum szerint csökkenőben
          this.osszesTetel = JSON.parse(this.egyenleg.tetelek)
            .slice()
            .sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0))
          this.buildParositottEgyenleg()
          //this.egyenleg[0].csalad_reszletek = JSON.parse(this.egyenleg[0].csalad_reszletek)
          //console.log(this.egyenleg)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  }
  async getCsaladEgyenleg(id, bizmodal = null) {
    this.aktivEgyenlegUserId = id
    await this.getKiirasBizonylatok(id)
    this.csegyenleg = []
    await this.http
      .get(
        '/api/egyenleg/' + id,
        {

        }
      )
      .subscribe({
        next: async (response: any) => {
          response.tetelek = JSON.parse(response.tetelek)
          this.csegyenleg = response
          if (!this.csaladiNezet) {
            this.csegyenleg.csalad = this.egyenleg[this.csegyenlegid].csalad
            this.csegyenleg.users = JSON.parse(this.egyenleg[this.csegyenlegid].csalad_reszletek)
            if (!this.csegyenleg.egyenleg) this.csegyenleg.egyenleg = 0
            this.kovetel = response.tetelek.filter(s => s.osszeg >= 0)
            this.kovetelnullaz = response.tetelek.filter(s => s.osszeg >= 0 && s.kapcsolat == null)
            this.jovair = response.tetelek.filter(s => s.osszeg < 0)
            this.buildParositottEgyenleg()
            console.log(response)
          } else {
            //this.csegyenleg = this.egyenleg[0]

          }
          await this.data.setStorage("csalad", response)
          if (bizmodal == "bizmodal") this.bizmodal.present();
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  }
  async getOsztalyEgyenleg(id, bizmodal = null) {
    await this.http
      .get(
        '/api/osztaly/egyenleg/' + id,
        {

        }
      )
      .subscribe({
        next: async (response: any) => {
          this.csegyenleg = ""
          this.kovetel = []
          this.jovair = []

          response.tetelek = JSON.parse(response.tetelek)
          if (response.zseb_egyenlegek == null)
            response.zseb_egyenlegek = []
          else
            response.zseb_egyenlegek = JSON.parse(response.zseb_egyenlegek)
          for (let j = 0; j < this.zsebek.length; j++) {
            this.zsebek[j].egyenleg = 0
            for (let i = 0; i < response.zseb_egyenlegek.length; i++) {
              this.zsebek[j].egyenleg = response.zseb_egyenlegek[this.zsebek[j].nev]

            }
          }
          this.csegyenleg = response
          if (!this.csaladiNezet) {
            this.csegyenleg.csalad = ""
            this.csegyenleg.users = []
            if (!this.csegyenleg.egyenleg) this.csegyenleg.egyenleg = 0
            this.kovetel = response.tetelek.filter(s => s.osszeg < 0)
            this.kovetelnullaz = []
            this.jovair = response.tetelek.filter(s => s.osszeg >= 0)
            this.buildParositottEgyenleg()
            //console.log(response)
          } else {
            //this.csegyenleg = this.egyenleg[0]

          }
          await this.data.setStorage("csalad", response)
          if (bizmodal == "bizmodal") this.bizmodal.present();
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  }



  getRowClass = (row) => {
    return {
      'row-color-blue': row.osszeg >= 0,
      'row-color-green': row.osszeg < 0
    };
  }
  getOsztalyRowClass = (row) => {
    return {
      'row-color-blue': row.osszeg < 0,
      'row-color-green': row.osszeg >= 0
    };
  }
  getCellClass = (row) => {
    return {
      'row-color-blue': row.osszeg >= 0,
      'row-color-green': row.osszeg < 0
    };
  }

  normalizeKapcsolat(value: any): string {
    if (value === null || value === undefined) return '';
    return String(value).replace(/^"+|"+$/g, '').trim();
  }

  tetelOsszeg(value: any): number {
    const amount = Number(value);
    return Number.isFinite(amount) ? amount : 0;
  }

  getTetelMaradek(item: any): number {
    return this.tetelOsszeg(item?.kovetel?.osszeg) - this.tetelOsszeg(item?.befizetve);
  }

  /**
   *  Kézi párosításnál csak a MÉG NYITOTT követeléseket kínáljuk fel.
   *  A teljesített tételek felkínálása félrevezető volt: a befizetés rájuk húzása
   *  túlfizetést csinált, holott a hátralék máshol áll.
   */
  get parositasraFelkinalt(): any[] {
    return (this.parositottTetelek || []).filter((it: any) => this.getTetelMaradek(it) > 0);
  }

  getTetelStatus(item: any): 'paid' | 'partial' | 'open' {
    const maradek = this.getTetelMaradek(item);
    const befizetve = this.tetelOsszeg(item?.befizetve);
    if (maradek <= 0 && befizetve > 0) return 'paid';
    if (befizetve > 0) return 'partial';
    return 'open';
  }

  getTetelStatusLabel(item: any): string {
    const status = this.getTetelStatus(item);
    if (status === 'paid') return 'Rendezve';
    if (this.tetelLejart(item)) return 'Lejárt';
    if (status === 'partial') return 'Részben rendezve';
    return 'Esedékes';
  }

  // Fizetési határidő (a tételhez tartozó számláról): hátralévő napok / lejárt-e
  tetelLejaratNap(item: any): number {
    const fh = item?.kovetel?.fiz_hat;
    return fh ? moment(fh).diff(moment(), 'days') : 0;
  }
  tetelLejart(item: any): boolean {
    if (this.getTetelStatus(item) === 'paid') return false;
    const fh = item?.kovetel?.fiz_hat;
    if (!fh) return false;
    return moment(fh).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD');
  }

  // Esedékességig hátralévő napok kiírva (a Bizonylatok menühöz hasonlóan).
  tetelLejaratSzoveg(item: any): string {
    if (this.getTetelStatus(item) === 'paid' || !item?.kovetel?.fiz_hat) return '';
    const nap = this.tetelLejaratNap(item);
    if (nap > 0) return `Esedékességig ${nap} nap`;
    if (nap === 0) return 'Ma esedékes';
    return `${Math.abs(nap)} napja lejárt`;
  }

  // A számla táblázat ikonjai: rendezve=today, esedékes=tomorrow, lejárt=leave.
  getTetelIcon(item: any): { src: string; title: string } {
    if (this.getTetelStatus(item) === 'paid')
      return { src: 'assets/icon/icons8-today-96.png', title: 'Rendezve' };
    if (this.tetelLejart(item))
      return { src: 'assets/icon/icons8-leave-96.png', title: 'Lejárt' };
    return { src: 'assets/icon/icons8-tomorrow-96.png', title: 'Esedékes' };
  }

  private normNev(value: any): string {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  // Díjbekérő-e a tételhez tartozó bizonylat (tipus 3).
  isDijbekero(kov: any): boolean {
    return kov && String(kov.tipus) === '3';
  }
  // Bizonylat típus-címke (a számlaszám mellé).
  dokTipusLabel(kov: any): string {
    if (!kov?.tipus) return '';
    const t = String(kov.tipus);
    if (t === '3') return 'Díjbekérő';
    if (t === '8') return 'Storno';
    if (t === '9') return 'Módosító';
    return 'Számla';
  }
  // Bizonylat típushoz tartozó css-osztály (szín): díjbekérő lila, storno szürke, módosító narancs.
  dokTipusClass(kov: any): string {
    const t = String(kov?.tipus || '');
    if (t === '3') return 'dijbekero';
    if (t === '8') return 'storno';
    if (t === '9') return 'modosito';
    return '';
  }
  // Van-e fizetés gomb: a backend resolver szerint fizethető díjbekérő, és még nincs rendezve.
  tetelFizetheto(item: any): boolean {
    const kov = item?.kovetel;
    if (!kov?.szamla || !kov?.fizetheto) return false;
    return this.getTetelStatus(item) !== 'paid';
  }

  // Igaz, ha ugyanahhoz a számlához (szamla) több követelés-tétel tartozik.
  szamlaTobbTetel(item: any): boolean {
    const szamla = item?.kovetel?.szamla;
    if (szamla === null || szamla === undefined || szamla === '') return false;
    const count = (this.parositottTetelek || [])
      .filter((it) => it?.kovetel?.szamla === szamla).length;
    return count > 1;
  }

  buildParositottEgyenleg() {
    const kovetelesek = Array.isArray(this.kovetel) ? this.kovetel : [];
    const jovairasok = Array.isArray(this.jovair) ? this.jovair : [];
    const usedCredits = new Set<any>();

    // 1) Közvetlen (kapcsolat alapú) párosítás. A követelést sekélyen másoljuk, hogy a
    //    díjbekérő-társítás ne módosítsa a nyers (legacy/lista) tételeket.
    const items = kovetelesek.map((koveteles) => {
      const kovetelesId = this.normalizeKapcsolat(koveteles?.id);
      const kozvetlen = jovairasok.filter((jovairas) => {
        const match = kovetelesId && this.normalizeKapcsolat(jovairas?.kapcsolat) === kovetelesId;
        if (match) usedCredits.add(jovairas);
        return match;
      });
      return { kovetel: { ...koveteles }, jovairasok: kozvetlen, auto: [] as any[] };
    });

    // 1/b) Minden kiíráshoz a backend resolver által megtalált bizonylat társítása
    //      (kiiras-bizonylatok endpoint, egyenleg id szerint). Ez adja a számlaszámot,
    //      a típust (díjbekérő/számla/storno/módosító), a fiz_hat-ot és a fizethetőséget.
    items.forEach((it) => {
      const doc = this.kiirasBizonylatok?.[it.kovetel?.id];
      if (!doc) return;
      it.kovetel.szamla = doc.szamla;
      it.kovetel.szamlaszam = doc.szamlaszam;
      it.kovetel.tipus = doc.tipus;
      it.kovetel.storno = doc.storno;
      it.kovetel.osszesen = doc.osszesen;
      it.kovetel.fizetheto = doc.fizetheto;
      if (!it.kovetel.fiz_hat) it.kovetel.fiz_hat = doc.fiz_hat;
    });

    // 2) Heurisztikus párosítás: nincs közvetlen kapcsolat, de láthatóan összetartoznak
    //    (azonos megnevezés és/vagy azonos összeg), és a követelésnek még van hátraléka.
    jovairasok.filter((j) => !usedCredits.has(j)).forEach((jovairas) => {
      const jOsszeg = Math.abs(this.tetelOsszeg(jovairas?.osszeg));
      const jNev = this.normNev(jovairas?.nev);
      let best: { it: any; score: number } | null = null;
      for (const it of items) {
        const fizetve = it.jovairasok.concat(it.auto)
          .reduce((s, c) => s + Math.abs(this.tetelOsszeg(c?.osszeg)), 0);
        const maradek = this.tetelOsszeg(it.kovetel?.osszeg) - fizetve;
        if (maradek <= 0) continue;
        const nevMatch = jNev !== '' && this.normNev(it.kovetel?.nev) === jNev;
        const osszegMatch = jOsszeg > 0 && Math.abs(this.tetelOsszeg(it.kovetel?.osszeg)) === jOsszeg;
        if (!nevMatch && !osszegMatch) continue;
        const score = (nevMatch ? 2 : 0) + (osszegMatch ? 1 : 0);
        if (!best || score > best.score) best = { it, score };
      }
      if (best) {
        best.it.auto.push(jovairas);
        usedCredits.add(jovairas);
      }
    });

    this.parositottTetelek = items.map((it) => {
      const jov = it.jovairasok.concat(it.auto);
      const befizetve = jov.reduce((sum, c) => sum + Math.abs(this.tetelOsszeg(c?.osszeg)), 0);
      return {
        kovetel: it.kovetel,
        jovairasok: jov,
        autoParositott: it.auto,    // heurisztikusan társított befizetések (UI jelzéshez)
        befizetve,
      };
    }).sort((a, b) => String(b.kovetel?.date || '').localeCompare(String(a.kovetel?.date || '')));

    this.parositatlanJovairasok = jovairasok
      .filter((jovairas) => !usedCredits.has(jovairas))
      .sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')));
  }

  // Egy heurisztikusan társított befizetés-e (nincs közvetlen kapcsolat).
  isAutoParositott(item: any, jovairas: any): boolean {
    return Array.isArray(item?.autoParositott) && item.autoParositott.indexOf(jovairas) !== -1;
  }

  // Admin: nem társított befizetés kézi párosítása egy követeléshez (perzisztens).
  async parositJovairast(jovairas: any, kovetelesId: any) {
    if (!jovairas?.id || !kovetelesId) return;
    await this.data.showLoading('Befizetés párosítása...');
    this.http.post('/api/szamla/parosit',
      { jovairasId: jovairas.id, kovetelesId: kovetelesId },
      { headers: { intezmeny: this.sajatIntezmeny.intezmenyId } })
      .subscribe({
        next: (resp: any) => {
          this.data.hideLoading();
          if (resp?.status === 'OK') {
            this.data.sendToast('Befizetés párosítva!', 'success');
            if (this.aktivEgyenlegUserId != null) this.getCsaladEgyenleg(this.aktivEgyenlegUserId);
          } else {
            this.data.sendToast(resp?.error || 'A párosítás nem sikerült!', 'error');
          }
        },
        error: (error) => {
          this.data.hideLoading();
          console.error('Párosítás hiba:', error);
          this.data.sendToast('A párosítás nem sikerült!', 'error');
        }
      });
  }

  initModal(id, i) {

    this.csegyenlegid = i
    this.egyenlegModalView = 'parositott'
    this.getCsaladEgyenleg(id)
    //this.form.patchValue({orszag:{id:1,nev:"Afganisztán"}})
    this.modal.present();
  }
  async initOsztalyModal(id, i) {

    this.csegyenlegid = i

    this.csegyenleg = ""
    this.kovetel = []
    this.jovair = []
    await this.getZsebek()
    await this.getOsztalyEgyenleg(id)
    //this.form.patchValue({orszag:{id:1,nev:"Afganisztán"}})
    this.osztalymodal.present();
  }
  initModal2(id, i, type = null) {
    console.log(id)
    if (type) this.tetel.patchValue({ tipus: type });
    //this.tetel.patchValue({ev:moment().format("YYYY"),honap:"1",alrendszer:"Étkezés"})

    this.csegyenlegid = i
    this.getCsaladEgyenleg(id)
    //this.form.patchValue({orszag:{id:1,nev:"Afganisztán"}})
    this.tetelmodal.present();
  }
  async initOsztalyModal2(id, i, type = null) {
    console.log(id)
    if (type) this.tetel.patchValue({ tipus: type });
    //this.tetel.patchValue({ev:moment().format("YYYY"),honap:"1",alrendszer:"Étkezés"})

    this.csegyenlegid = i
    this.csegyenleg = ""
    this.kovetel = []
    this.jovair = []
    await this.getZsebek()
    await this.getOsztalyEgyenleg(id)
    //this.form.patchValue({orszag:{id:1,nev:"Afganisztán"}})
    this.osztalytetelmodal.present();
  }
  async initModal3(id, i) {

    this.csegyenlegid = i
    await this.getCsaladEgyenleg(id, "bizmodal")
    //this.form.patchValue({orszag:{id:1,nev:"Afganisztán"}})

  }
  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  getEletut() {
    this.http
      .get(
        'https://merfoldkovek.oh.gov.hu/api/User/Timeline',
        {

        }
      )
      .subscribe({
        next: (response) => {
          //this.allomany = response
          console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          /*
          {
              "allapot": "NincsMegFeliratkozva",
              "formatumVerzio": 1,
              "generalva": "0001-01-01T00:00:00",
              "adatok": null,
              "adatAllapot": "OsszeallitasAlatt",
              "leiratkozasOka": "Oktazonvaltozas",
              "leiratkozva": null,
              "letrehozva": null,
              "megtekintveUgyintezokent": false,
              "ugyintezoOktazon": null,
              "isSucceeded": true,
              "reasonOfFail": null,
              "muveletAzonosito": "67155014-3c68-47cc-802d-a68aee09ce1c",
              "errorCode": 0,
              "errorCodeString": "0000",
              "time": "2025-01-17T16:35:45.4874766+01:00"
          } */
        },
      });
  }

  getAllomany() {
    let headers = {
      intezmeny: this.sajatIntezmeny.intezmenyId
    }

    this.http
      .get(
        '/api/nyilvantartas/szulo/' + this.sajatIntezmeny.intezmenyId,
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allomany = response
          console.log(this.allomany)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/csoport/' + this.sajatIntezmeny.intezmenyId,
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.csoport = response
          console.log(this.csoport)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/telepules/hu',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.telepules = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/allampolgarsag',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allampolgar = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/orszagok',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.orszag = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }



  cancel() {
    this.modal.dismiss(null, 'cancel');
  }
  cancelOsztaly() {
    this.osztalymodal.dismiss(null, 'cancel');
  }
  cancel2() {
    this.tetelmodal.dismiss(null, 'cancel');
    this.tetel.reset();
  }
  cancelosztaly2() {
    this.osztalytetelmodal.dismiss(null, 'cancel');
    this.osztalytetel.reset();
  }
  cancel3() {
    this.bizmodal.dismiss(null, 'cancel');
  }

  confirm(mode) {
    this.bizmodal.dismiss(null, 'ok');
    this.bizonylattipus = mode;
    this.modal.present();
  }
  confirm2() {
    this.tetelmodal.dismiss(null, 'ok');
    // A nap-tartományt csak akkor küldjük, ha tényleg szűkít – így a havi kiírás
    // ugyanazt a (NULL/NULL) sort írja be, mint eddig.
    const tetelHatar = this.idoszakHatar(this.tetel.value);
    let body = { kapcsolat: this.tetel.value.koveteles?.id ? '"' + this.tetel.value.koveteles?.id + '"' : null, alrendszer: this.tetel.value.alrendszer, ev: this.tetel.value.ev, honap: this.tetel.value.honap, nap_tol: tetelHatar.reszleges ? tetelHatar.tol : null, nap_ig: tetelHatar.reszleges ? tetelHatar.ig : null, users: this.ebedusers, nev: this.tetel.value.nev, osszeg: this.tetel.value.tipus == "Követelés" || this.tetel.value.tipus == "Követelés alrendszerből" ? this.tetel.value.osszeg : -this.tetel.value.osszeg, csalad: this.egyenleg[this.csegyenlegid].csalad, date: moment().format("YYYY-MM-DD HH:mm:ss"), szamla: null }

    // "Jóváírás követelésből" esetén, ha a követeléshez tartozik díjbekérő, a végszámlát a
    // backend (schedulePaidProformaInvoice) állítja ki a díjbekérőből és egyben kiegyenlíti azt.
    // Ilyenkor NEM hívjuk a bizonylatCreate-et, különben másodszor is kiállítaná a számlát
    // (duplikáció). Díjbekérő nélküli követelésnél marad a régi (frontend) bizonylat-kiállítás.
    const backendAllitjaKiSzamlat =
      this.tetel.value.tipus == 'Jóváírás követelésből' && this.tetel.value.koveteles?.szamla != null;

    this.http.post("/api/egyenleg/kiir", body).subscribe((res: any) => {
      //console.log(res)
      if (this.tetel.value.dijbekero == true && !backendAllitjaKiSzamlat) this.bizonylatCreate(this.tetel.value, res.id)
      else {
        this.tetel.reset();
        this.getEgyenleg();
        this.getCsaladEgyenleg(this.csegyenlegid);
        this.data.sendToast("Tétel kiírva!", "success")
      }
    })

  }
  /* ---------- Tömeges ebédkiírás ----------
   * Végigmegy az ÖSSZES családon (mintha mindegyiknél egyenként rányomnánk a kiírásra),
   * a megadott év+hónapra kiszámítja a fizetendő ebédet (UGYANAZZAL a képlettel, mint a
   * családonkénti kiírás), listába hozza. A nem kívánt sorok kivehetők, majd egyben kiírható.
   */
  tomegesInit() {
    this.tomeges = { ev: moment().year(), honap: moment().month() + 1, idoszak: 'teljes', nap_tol: 1, nap_ig: 15, fut: false, kesz: false, sorok: [], halad: 0, total: 0, dijbekero: false, biztomb: '' };
    if (!this.tombok || !this.tombok.length) this.getTomb(); // számlatömbök a díjbekérőhöz
    this.tomegesmodal.present();
  }
  // Egy család havi ebéd-fizetendője – PONTOSAN a getAdatFromAlrendszer képlete
  // (közös számítás: util/etkezes-ar.ts).
  private szamoldEbed(response: any[], napTol: number | null = null, napIg: number | null = null): number {
    let v = 0;
    (response || []).forEach((element: any) => {
      element.adatok = JSON.parse("[" + element.adatok + "]");
      try { element.etkezes_hely_adatok = JSON.parse(element.etkezes_hely_adatok); } catch (e) { }
      v += etkezesIdoszakOsszeg(element, napTol, napIg);
    });
    return v;
  }
  async tomegesSzamit() {
    const csaladok = Array.isArray(this.egyenleg) ? this.egyenleg : [];
    // A választott időszak EGYSZER dől el, a futás elején: ha közben átállítanák a
    // választót, a már kiszámolt és a még hátralévő sorok más tartományra szólnának.
    this.tomeges.hatar = this.idoszakHatar(this.tomeges);
    this.tomeges.fut = true; this.tomeges.kesz = false; this.tomeges.sorok = []; this.tomeges.halad = 0;
    // Csak azok a családok, ahol van tanuló (étkező).
    const feladatok = csaladok.map((row: any) => {
      let tagok: any[] = [];
      try { tagok = JSON.parse(row.csalad_reszletek || '[]'); } catch (e) { tagok = []; }
      return { row, tanulok: tagok.filter((m: any) => m.type === 'tanulo'), szulok: tagok.filter((m: any) => m.type === 'szulo') };
    }).filter((x: any) => x.tanulok.length > 0);
    this.tomeges.total = feladatok.length;

    const sorok: any[] = [];
    const batch = 6; // korlátozott párhuzamosság: gyors, de nem terheli túl a backendet
    for (let i = 0; i < feladatok.length; i += batch) {
      await Promise.all(feladatok.slice(i, i + batch).map(async (f: any) => {
        const users = f.tanulok.map((m: any) => ({ oktazon: m.id }));
        let osszeg = 0;
        try {
          const resp: any = await firstValueFrom(this.http.post(
            '/api/etkezes/tanulo/' + this.tomeges.ev + '/' + this.tomeges.honap + '/' + this.sajatIntezmeny.intezmenyId, users));
          osszeg = this.szamoldEbed(resp, this.tomeges.hatar.tol, this.tomeges.hatar.ig);
        } catch (e) { osszeg = 0; }
        sorok.push({
          csalad: f.row.csalad,
          nev: f.tanulok.map((m: any) => m.nev).join(', '),
          users,
          szuloId: f.szulok[0]?.id || null,   // a díjbekérő címzettje (gondviselő)
          osszeg: Math.round(osszeg),
          include: osszeg > 0,
        });
        this.tomeges.halad++;
      }));
    }
    sorok.sort((a, b) => String(a.nev).localeCompare(String(b.nev), 'hu'));
    this.tomeges.sorok = sorok;
    this.tomeges.fut = false; this.tomeges.kesz = true;
  }
  tomegesKivalasztottDb() { return (this.tomeges.sorok || []).filter((s: any) => s.include && s.osszeg > 0).length; }
  tomegesOsszesen() { return (this.tomeges.sorok || []).filter((s: any) => s.include).reduce((sum: number, s: any) => sum + (s.osszeg || 0), 0); }
  // Egy család díjbekérőjének elkészítése a kiírt tétel (tetelid) alapján – a családonkénti
  // bizonylatCreate logikájával (POST /szamla/create → GET /nav/geninvoice).
  private async tomegesDijbekeroEgy(s: any, tetelid: any) {
    const body = {
      bizonylattipus: 3, // díjbekérő
      tetelek: [{ id: tetelid, nev: this.tomegesTetelNev(), alrendszer: 'Étkezés', osszeg: s.osszeg, afa: 'AAM', mennyiseg: '1', megyseg: this.tomeges.hatar?.reszleges ? 'db' : 'hó' }],
      form: { kapja: s.szuloId, osszesen: s.osszeg, biztomb: this.tomeges.biztomb, fizmod: 'Bankkártya' },
      intezmeny: this.sajatIntezmeny,
    };
    const resp: any = await firstValueFrom(this.http.post('/api/szamla/create', body));
    const szlaId = resp && resp[0] ? resp[0].id : null;
    if (szlaId) await firstValueFrom(this.http.get('/api/nav/geninvoice/' + szlaId + '/' + this.sajatIntezmeny.intezmenyId));
  }
  /** A kiírt tétel megnevezése – részleges időszaknál a napok is benne vannak. */
  private tomegesTetelNev(): string {
    return 'Étkezés - ' + this.tomeges.honap + '. hónap'
      + (this.tomeges.hatar?.reszleges ? ` (${this.tomeges.hatar.tol}–${this.tomeges.hatar.ig}.)` : '');
  }

  async tomegesKiir() {
    const kiirandok = (this.tomeges.sorok || []).filter((s: any) => s.include && s.osszeg > 0);
    if (!kiirandok.length) { this.data.sendToast('Nincs kiírandó tétel.', 'warning'); return; }
    if (this.tomeges.dijbekero && !this.tomeges.biztomb) { this.data.sendToast('Válassz számlatömböt a díjbekérőhöz.', 'warning'); return; }
    await this.data.showLoading('Kiírás folyamatban...');
    let ok = 0, hiba = 0, dijOk = 0, dijHiba = 0;
    for (const s of kiirandok) {
      const body = {
        kapcsolat: null, alrendszer: 'Étkezés', ev: this.tomeges.ev, honap: this.tomeges.honap,
        nap_tol: this.tomeges.hatar?.reszleges ? this.tomeges.hatar.tol : null,
        nap_ig: this.tomeges.hatar?.reszleges ? this.tomeges.hatar.ig : null,
        users: s.users, nev: this.tomegesTetelNev(), osszeg: s.osszeg,
        csalad: s.csalad, date: moment().format('YYYY-MM-DD HH:mm:ss'), szamla: null,
      };
      try {
        const res: any = await firstValueFrom(this.http.post('/api/egyenleg/kiir', body));
        ok++;
        if (this.tomeges.dijbekero) {
          try { await this.tomegesDijbekeroEgy(s, res?.id); dijOk++; }
          catch (e) { dijHiba++; }
        }
      } catch (e) { hiba++; }
    }
    this.data.hideLoading();
    const dijResz = this.tomeges.dijbekero ? `, díjbekérő: ${dijOk}${dijHiba ? ' (' + dijHiba + ' hiba)' : ''}` : '';
    this.data.sendToast(`Tömeges kiírás kész: ${ok} család${hiba ? ', ' + hiba + ' hiba' : ''}${dijResz}.`, (hiba || dijHiba) ? 'warning' : 'success');
    await this.tomegesmodal.dismiss();
    this.getEgyenleg();
  }

  confirmosztaly2() {
    this.osztalytetelmodal.dismiss(null, 'ok');
    let body = { kapcsolat: null, szlaszam: this.osztalytetel.value.szla, alrendszer: this.osztalytetel.value.zseb, nev: this.osztalytetel.value.nev, osszeg: this.osztalytetel.value.tipus == "Követelés" ? -this.osztalytetel.value.osszeg : this.osztalytetel.value.osszeg, csalad: this.oegyenleg[this.csegyenlegid].id, date: moment().format("YYYY-MM-DD HH:mm:ss"), szamla: null }

    this.http.post("/api/egyenleg/kiir", body).subscribe((res: any) => {
      this.osztalytetel.reset();
      this.getEgyenleg();
      this.getOsztalyEgyenleg(this.csegyenlegid);
      this.data.sendToast("Tétel kiírva!", "success")
    })

  }

  fotipusvalt(e) {
    this.egyenlegMode = e.target.value
  }


  async bizonylatCreate(tetelek, tetelid) {
    await this.data.showLoading("Bizonylat létrehozása...");
    let users = this.csegyenleg.users.filter((item: any) => item.type == "szulo");
    const body = {
      bizonylattipus: tetelek.tipus.indexOf("Jóváírás") != -1 ? 1 : 3,
      tetelek: [{ "id": tetelid, "nev": tetelek.nev, "alrendszer": tetelek.alrendszer || "", "osszeg": tetelek.osszeg, "afa": "AAM", "mennyiseg": "1", "megyseg": "hó" }],
      form: { kapja: users[0]?.id, osszesen: tetelek.osszeg, biztomb: tetelek.biztomb, fizmod: tetelek.tipus.indexOf("Jóváírás") != -1 ? "Készpénz" : "Bankkártya" },
      intezmeny: this.sajatIntezmeny
    }
    this.http
      .post(
        '/api/szamla/create',
        body
      )
      .subscribe({
        next: (response: any) => {
          this.data.hideLoading();
          this.data.sendToast("Bizonylat létrehozva!", "success")
          this.http
            .get(
              '/api/nav/geninvoice/' + response[0]?.id + '/' + this.sajatIntezmeny.intezmenyId
            )
            .subscribe({
              next: (response2) => {
                this.data.sendToast("Bizonylat generálása sikeres!", "success")
                if (this.tetel.value.dijbekero == true) {
                  this.getEgyenleg();
                  this.getCsaladEgyenleg(this.csegyenlegid);
                  this.tetel.reset();
                }
              },
              error: (error) => {
                console.error('Error fetching data:', error);
                //this.modalController.dismiss();
                this.data.sendToast("Hiba történt: " + error, "error")
              },
            });
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.data.hideLoading();
          //this.modalController.dismiss();
          this.data.sendToast("Hiba történt: " + error, "error")
        },
      });
  }

  selectChangedAnyanyelv(e) {

  }

  /* ── Kiírás javítása / törlése, díjbekérő érvénytelenítése (admin) ── */

  adminTetel(): boolean { return !this.csaladiNezet; }

  tetelSzerkNyit(kovetel: any) {
    this.tetelSzerk = { id: kovetel.id, nev: kovetel.nev, osszeg: kovetel.osszeg };
  }
  tetelSzerkMegse() { this.tetelSzerk = null; }

  async tetelSzerkMent() {
    if (!this.tetelSzerk?.id) return;
    this.tetelMuvelet = true;
    try {
      await firstValueFrom(this.http.put(`/api/egyenleg/tetel/${this.tetelSzerk.id}`, {
        nev: this.tetelSzerk.nev,
        osszeg: this.tetelSzerk.osszeg,
      }));
      this.data.sendToast('A pénzügyi tétel módosítva.', 'success');
      this.tetelSzerk = null;
      await this.egyenlegUjratolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A módosítás nem sikerült.', 'error');
    } finally { this.tetelMuvelet = false; }
  }

  async tetelTorol(kovetel: any) {
    if (!confirm(`Biztosan törlöd ezt a kiírást?\n\n${kovetel?.nev} – ${kovetel?.osszeg} Ft\n\nÉtkezésnél az érintett napok visszakerülnek kiírás előtti állapotba.`)) return;
    this.tetelMuvelet = true;
    try {
      const r: any = await firstValueFrom(this.http.delete(`/api/egyenleg/tetel/${kovetel.id}`));
      let uzenet = 'A kiírás törölve.';
      if (r?.etkezesVissza) uzenet += ` ${r.etkezesVissza} étkezési nap újra kiírható.`;
      if (r?.dijbekeroErvenytelen) uzenet += ' A hozzá tartozó díjbekérő érvénytelenítve.';
      this.data.sendToast(uzenet, 'success');
      await this.egyenlegUjratolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A törlés nem sikerült.', 'error');
    } finally { this.tetelMuvelet = false; }
  }

  async dijbekeroErvenytelenit(kovetel: any) {
    if (!confirm('Érvényteleníted ezt a díjbekérőt?\n\nA sorszám megmarad (nem használjuk újra), a kiírás pedig felszabadul, hogy új, helyes díjbekérő készülhessen róla.')) return;
    this.tetelMuvelet = true;
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/szamla/dijbekero/${kovetel.szamla}/ervenytelenit`, {}));
      this.data.sendToast(`Díjbekérő érvénytelenítve (${r?.felszabaditott_kiiras || 0} kiírás felszabadult).`, 'success');
      await this.egyenlegUjratolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az érvénytelenítés nem sikerült.', 'error');
    } finally { this.tetelMuvelet = false; }
  }

  private async egyenlegUjratolt() {
    if (this.aktivEgyenlegUserId) await this.getCsaladEgyenleg(this.aktivEgyenlegUserId);
    this.getEgyenleg();
  }
}
